import type { Course } from '@mc/api'
import { useBucket } from '@mc/experiments-react'
import { useStaticData } from '@mc/static-data-react'
import { PEN_6957_V2_CM_SKINNY_CM_FLAG } from '../constants'
import { isEligibleSlug } from '../skills'

/**
 * Gates the Skinny CM modal. It only opens for users bucketed into a variant
 * on a class that has ingested skills data.
 */
export const useSkinnyCmExperiment = () => {
  const bucket = useBucket(PEN_6957_V2_CM_SKINNY_CM_FLAG)
  const { course } = useStaticData<{ course: Course }>()

  const shouldShow =
    bucket?.startsWith('variant') && isEligibleSlug(course?.slug)

  return { shouldShow, slug: course?.slug ?? '' }
}
